import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8051/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para adicionar token de autenticação
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para tratar erros de autenticação
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const authService = {
  login: async (email, password) => {
    const response = await api.post('/login', { email, password });
    return response.data;
  },
  
  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  },
  
  getCurrentUser: () => {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  },
  
  isAuthenticated: () => {
    return !!localStorage.getItem('token');
  }
};

export const clientService = {
  getClients: async () => {
    const response = await api.get('/clientes');
    return response.data;
  },
  
  getClientById: async (id) => {
    const response = await api.get(`/clientes/${id}`);
    return response.data;
  },
  
  getClientUsers: async (clientId) => {
    const response = await api.get(`/clientes/${clientId}/users`);
    return response.data.data;
  },
  
  createEmpresa: async (empresaData) => {
    const response = await api.post('/empresas', empresaData);
    return response.data;
  },
  
  getCidades: async () => {
    const response = await api.get('/registros/cidade');
    return response.data;
  }
};

export const dashboardService = {
  getStats: async () => {
    const response = await api.get('/clientes/dashboard/stats');
    return response.data;
  }
};

export const downloadService = {
  /**
   * Busca informações de versões disponíveis para download
   * @param {string|number} id - ID da versão (opcional, padrão: 'latest')
   * @returns {Promise<Object>} Dados das versões latest e previous
   */
  getDownloadVersions: async (id = 'latest') => {
    try {
      const response = await api.get(`/app/get-url-download-version/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar versões de download:', error);
      throw error;
    }
  }
};

export default api; 